import React, { Component } from 'react';

import Button from 'base/components/Button';

export default class StartPage extends Component {
  render() {
    return (
      <div className="startpage-body">
        <div className="startpage-container">
            {/* <div className="startpage-logo" /> */}
            <h1 className="startpage-header">Słowiańska <span>Wixa</span></h1>
            <p className="startpage-subheader">Rajd jesienny W1 & W8</p>
            <span className="startpage-buttons-wrapper">
              <Button url="/entry-form">Zapisz się!</Button>
              {/* <Button url="/rooms">Pokoje</Button> */}
            </span>
        </div>
        <p className="promo-text">Aplikację do obsługi wydarzeń rozwija <a href="http://nativeflow.napwr.pl">KN Native Flow</a></p>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/views/StartPage.js